import { useStoreActions } from '@src/store/store';

type TActionLoad = () => Promise<void>;

export function useLoadRestrictions(): TActionLoad {
  const load: TActionLoad = useStoreActions((actions) => actions.restrictions.load);

  return load;
}
